import React from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

const SelectAllBtn = (props) => {
  const { name, list = [] } = props;
  const [,, helperProps] = useField(name);
  const { t } = useTranslation();
  // const list = Object.keys(env.lvs);

  return (
    <div className="form-group">
      <a className="text-primary" onClick={() => {
        helperProps.setValue(list);
      }}>
        {t('Select All')}
      </a>
      &nbsp;
      { '|' }
      &nbsp;
      <a className="text-primary" onClick={() => {
        helperProps.setValue([]);
      }}>
        {t('Deselect All')}
      </a>
    </div>

  );
};

export default SelectAllBtn;
